<template>
  <div id="Login">
    <div class="xv_default_header">
      <div>
        <img src="../../../assets/Thermometer_green.png" alt />
      </div>
      <div>
        <span>Xerovi</span>
      </div>
    </div>
    <div class="row xv_login_wrap">
      <div class="col-6 left_sec">
        <label class="title">Welcome back!</label>
        <div class="xv_login_form">
          <div>
            <input type="text" placeholder="Email address" />
          </div>
          <div>
            <input type="text" placeholder="Password" />
          </div>
          <div>
            <button class="log_in" @click="login()">Log in</button>
          </div>
          <div>
            <button class="help">Need help logging in?</button>
          </div>
        </div>
        <div class="xv_login_footer">
          Not a customer yet?
          <button class="start" @click="get_start()">Get Started</button>
        </div>
      </div>
      <div class="col-6 right_sec">
        <img src="../../../assets/login.jpg" alt />
      </div>
    </div>
    <div class="xv_default_footer">
      <button>Terms</button>
      <button>Policy</button>
    </div>

    <!-- Signup modal -->
    <modal name="signup" transition="pop-out" :width="900" height="auto">
      <signUp></signUp>
    </modal>
  </div>
</template>

<script>
import signUp from "../signup/signup.vue";

export default {
  name: "Login",
  components: {
    signUp
  },
  data() {
    return {};
  },
  mounted() {},
  methods: {
    login: function() {
      this.$router.push("/xv-admin/dashboard");
    },
    get_start: function() {
      this.$modal.show("signup");
    }
  }
};
</script>
